/* eslint-disable */
// import external dependencies
import 'jquery';
import 'custom-event-polyfill';

// Import everything from autoload
import './autoload/_bootstrap.js';

// Import Owl Carousel
import Router from './util/Router';
import OwlCarousel from './owl.carousel.min';

// import local dependencies
import './util/customSelect';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import templateFlexiDefault from './routes/template-flexi-default';
import templateListing from './routes/template-listing';
import templateStrategicPlan from './routes/template-strategic-plan';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Flexible
  templateFlexiDefault,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  templateListing,
  // Strategic plan template
  templateStrategicPlan,

});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js